export default __webpack_public_path__ + "static/media/burger.6ae20605.svg";